import { createAction } from 'typesafe-actions'

export const init = createAction('CMD / init')()
